import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Text,
    Button,
    UnorderedList,
    ListItem,
} from '@chakra-ui/react';

export interface InvoiceArithmeticBlockModalProps {
    isOpen: boolean;
    onClose: () => void;
    issues: string[];
}

const InvoiceArithmeticBlockModal = ({
    isOpen,
    onClose,
    issues,
}: InvoiceArithmeticBlockModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
                <ModalHeader fontSize="xl" fontWeight="bold" color="gray.900">
                    Cannot submit invoice
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={4}>
                    <Text fontSize="md" color="gray.700" mb={3}>
                        You cannot submit this invoice until all arithmetic flags are resolved. Fix the issues
                        below, then try submitting again.
                    </Text>
                    {issues.length > 0 && (
                        <UnorderedList spacing={2} pl={5}>
                            {issues.map((issue, idx) => (
                                <ListItem key={idx}>
                                    <Text fontSize="sm" color="gray.800">
                                        {issue}
                                    </Text>
                                </ListItem>
                            ))}
                        </UnorderedList>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button size="action" onClick={onClose}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default InvoiceArithmeticBlockModal;

